import { render, staticRenderFns } from "./TiposMetas.vue?vue&type=template&id=d51cdbda&scoped=true&"
import script from "./TiposMetas.vue?vue&type=script&lang=js&"
export * from "./TiposMetas.vue?vue&type=script&lang=js&"
import style0 from "./TiposMetas.vue?vue&type=style&index=0&id=d51cdbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51cdbda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow,VTab,VTabItem,VTabs})
